import React from "react";
import classNames from "classnames";

import { Themes } from "custom-types/Themes";

import LinkBase from "components/LinkBase";

interface Props extends React.AnchorHTMLAttributes<HTMLElement> {
  theme?: Themes.preferredPickupPartner | Themes.pickup;
}

const Chip: React.FC<Props> = ({ children, className, theme, ...others }) => {
  const isPreferredPickupPartner = theme === Themes.preferredPickupPartner;
  const isPickup = isPreferredPickupPartner || theme === Themes.pickup;

  const classes = classNames(
    "font-bold px-md rounded-full text-xs inline-flex items-center",
    { "bg-pickup text-white": isPreferredPickupPartner },
    { "bg-green-60 py-0.5": !isPreferredPickupPartner },
    className
  );

  return (
    <LinkBase defaultAs="span" className={classes} {...others}>
      <span>{isPickup && !children ? "Pickup" : children}</span>
      {isPreferredPickupPartner && <i className="ml-xs text-sm">&#10038;</i>}
    </LinkBase>
  );
};

export default Chip;
